import MediaCatalog from "@/components/feature/MediaCatalog";
import { movieGenres } from "@/lib/media";

export default function Movies() {
  return (
    <MediaCatalog
      kind="movie"
      breadcrumb="电影"
      title="电影分类"
      subtitle="Movie Collection"
      intro="汇集动作、科幻、悬疑、爱情、战争等多种类型的热门电影，支持按类型、地区、年份筛选与排序，助你快速找到想看的精彩大片。"
      genreOptions={movieGenres}
      meta={{
        title: "电影分类 - 免费观看大片在线观看",
        description:
          "免费观看大片在线观看电影分类页，提供动作、科幻、悬疑、爱情等多类型热门电影资源，支持类型、地区、年份筛选与排序，快速查找想看的电影。",
        keywords: "电影分类,热门电影,在线电影,高清大片,电影资源,免费观看大片在线观看",
      }}
    />
  );
}